/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const lastUpdatedDate = new Date(1670284800000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: null,
        description: null,
        lastUpdatedDate: "Tue Dec 06 2022 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: "sync-logs",
        type: "destination",
        icon: null,
        toc: [{
          "value": "Overview",
          "depth": 0,
          "id": "overview"
        }]
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      h2: "h2",
      p: "p",
      ul: "ul",
      li: "li",
      a: "a",
      strong: "strong"
    }, _provideComponents(), props.components);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.h2, {
        id: "overview",
        children: "Overview"
      }), "\n", _jsx(_components.p, {
        children: "This represents a placeholder destination that doesn't send data anywhere.\nRecords are still queried, processed, and logged just as if they\nwere sent to a real destination."
      }), "\n", _jsx(_components.p, {
        children: "Though Hightouch doesn't send data to any third-party destination, running a sync to this destination means that:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["The sync still appears in the ", _jsxs(_components.a, {
            href: "https://app.hightouch.com/syncs",
            children: [_jsx(_components.strong, {
              children: "Syncs"
            }), " page"]
          }), "."]
        }), "\n", _jsxs(_components.li, {
          children: ["You can use the in-app ", _jsx(_components.a, {
            href: "/syncs/debugger",
            children: "live debugger"
          }), " to observe sync runs."]
        }), "\n", _jsxs(_components.li, {
          children: ["You can view sync logs in ", _jsx(_components.a, {
            href: "/syncs/warehouse-sync-logs",
            children: "Warehouse Sync Logs"
          }), "."]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: "You can use this to log data and perform audits. Use cases include:"
      }), "\n", _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["Testing and reviewing model query results in the ", _jsx(_components.a, {
            href: "/syncs/debugger",
            children: "debugger"
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["Holdout groups for ", _jsx(_components.a, {
            href: "/customer-studio/splits",
            children: "audience Splits"
          }), ", to include\nthe holdout group in ", _jsx(_components.a, {
            href: "/syncs/warehouse-sync-logs",
            children: "Sync Logs"
          })]
        }), "\n", _jsxs(_components.li, {
          children: ["Setting up ", _jsx(_components.a, {
            href: "/syncs/alerting",
            children: "Alerts"
          }), " on query errors to receive warnings\nat a higher frequency than you may wish to schedule concrete data syncs"]
        }), "\n"]
      }), "\n", _jsx(_components.p, {
        children: "This destination doesn't require any configuration."
      })]
    });
  }
}
export default MDXContent;
